import { StyledMainButton } from "./styles";

interface MainButtonComponentProps {
	children?: React.ReactNode;
	onClick: () => void;
	disabled?: boolean;
	loading?: boolean;
	icon?: React.ReactNode;
	style?: React.CSSProperties;
	type?: "primary" | "default" | "dashed" | "link" | "text" | undefined;
}

const MainButtonComponent = (props: MainButtonComponentProps) => {
	const { onClick, disabled, loading, children, icon, style, type = "primary" } = props;

	return (
		<StyledMainButton
			icon={icon}
			type={type}
			onClick={onClick}
			disabled={disabled}
			loading={loading}
			style={style}
		>
			{children}
		</StyledMainButton>
	);
};

export default MainButtonComponent;